import React, { useState, useEffect} from 'react';

const AddTaskModal = ({ onClose, onSubmit, editTask }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [priority, setPriority] = useState('MEDIUM');
  const [type, setType] = useState('FEATURE');

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!title.trim()) {
      alert('Please enter a task title');
      return;
    }

    onSubmit({
      title,
      description,
      priority,
      type,
      id: editTask?.id
    });
  };

  useEffect(() => {
  if (editTask) {
    setTitle(editTask.title || '');
    setDescription(editTask.description || '');
    setPriority(editTask.priority || 'MEDIUM');
    setType(editTask.type || 'FEATURE');
  }
  }, [editTask]);

  return (
    <div className="modal show">
      <div className="modal-content">
        <div className="modal-header">
          <h2>{editTask ? 'Edit Task' : 'Add New Task'}</h2>
          <span className="close" onClick={onClose}>&times;</span>
        </div>
        <div className="modal-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="taskTitle">Task Title *</label>
              <input
                type="text"
                id="taskTitle"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter task title"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="taskDescription">Description</label>
              <textarea
                id="taskDescription"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Enter task description"
                style={{ minHeight: '80px', resize: 'vertical' }}
              />
            </div>

            <div className="form-grid-2">
              <div className="form-group">
                <label htmlFor="taskPriority">Priority</label>
                <select
                  id="taskPriority"
                  value={priority}
                  onChange={(e) => setPriority(e.target.value)}
                >
                  <option value="LOW">Low</option>
                  <option value="MEDIUM">Medium</option>
                  <option value="HIGH">High</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="taskType">Type</label>
                <select
                  id="taskType"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                >
                  <option value="FEATURE">Feature</option>
                  <option value="BUG">Bug</option>
                  <option value="ENHANCEMENT">Enhancement</option>
                  <option value="DOCUMENTATION">Documentation</option>
                  <option value="PERFORMANCE">Performance</option>
                  <option value="TECHNICAL_DEBT">Technical Debt</option>
                </select>
              </div>
            </div>
          </form>
        </div>
        <div className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-submit" onClick={handleSubmit}>
            { editTask ? 'Update Task' : 'Add to Backlog'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTaskModal;
